import React from "react";
import { Container, Row, Col, Card, Accordion } from "react-bootstrap";
// import FAQ from "./FAQ";
import BlogFAQ from "./BlogFAQ";

function InternalBlog() {
    return (
        <section className="py-5 content-wrapper">
            <Container>
                <Row className="g-4">

                    {/* LEFT: TABLE OF CONTENTS */}
                    <Col lg={3}>
                        <div className="toc sticky-toc">
                            <h6 className="toc-title">Table of Contents</h6>

                            <ul className="toc-list">
                                <li>
                                    <a href="#takeawys">Key Takeaways</a>
                                </li>

                                <li>
                                    <a href="#most-businesses-dont-know-discover-is-their-biggest-google-traffic-source">
                                        Most Businesses Don't Know Discover Is Their Biggest Google Traffic Source
                                    </a>
                                </li>

                                <li>
                                    <a href="#three-weeks-not-two-heres-what-that-actually-means-for-reading-your-data">
                                        Three Weeks. Not Two. Here's What That Actually Means for Reading Your Data
                                    </a>
                                </li>

                                <li>
                                    <a href="#what-the-google-algorithm-actually-changed-inside-discover">
                                        What the Google Algorithm Actually Changed Inside Discover
                                    </a>
                                </li>

                                <li>
                                    <a href="#the-local-content-advantage-that-us-businesses-should-be-capitalizing-on-right-now">
                                        The Local Content Advantage That U.S. Businesses Should Be Capitalizing on Right Now
                                    </a>
                                </li>

                                <li>
                                    <a href="#blogfaq">FAQ</a>
                                </li>
                            </ul>
                        </div>
                    </Col>


                    {/* RIGHT CONTENT */}
                    <Col lg={9}>

                        {/* Key Takeaways */}
                        <Card className="p-4 shadow-sm right-key" id="takeawys">
                            {/* <div className="right-key"> */}
                            <h4 className="mb-4">Key Takeaways</h4>

                            <p>
                                February 2026 was historic because Google split Search and
                                Discover into two different algorithm systems.
                            </p>

                            <p>
                                Discover now drives a large portion of Google publisher
                                traffic, making it a critical visibility channel.
                            </p>

                            <p>
                                Three things rewarded in the update: local content, topic
                                expertise, and original research.
                            </p>
                            {/* </div> */}
                        </Card>


                        {/* SECTION 1 */}
                        <div
                            className="mt-3"
                            id="most-businesses-dont-know-discover-is-their-biggest-google-traffic-source"
                        >
                            <h4>
                                Most Businesses Don't Know Discover Is Their Biggest Google Traffic Source
                            </h4>

                            <p>
                                Google Discover is the content feed that appears in the Google
                                mobile app before a search is even made.
                            </p>

                            <p>
                                Instead of searching, users scroll through personalized
                                articles based on interests and activity.
                            </p>

                            <Card className="p-3 mt-4 shadow-sm highlight-card">
                                <p>
                                    Discover now drives 68% of Google-sourced publisher
                                    traffic while traditional search drives only 27%.
                                </p>
                            </Card>
                        </div>


                        {/* SECTION 2 */}
                        <div
                            className="mt-3"
                            id="three-weeks-not-two-heres-what-that-actually-means-for-reading-your-data"
                        >
                            <h4>
                                Three Weeks. Not Two. Here's What That Actually Means for Reading Your Data
                            </h4>

                            <p>
                                The rollout started February 5th and completed February 27th,
                                taking 22 days instead of two weeks.
                            </p>

                            <Card className="p-3 mt-3 shadow-sm highlight-card">
                                <p>
                                    Wait for the full rollout to complete before analyzing
                                    traffic changes.
                                </p>
                            </Card>
                        </div>


                        {/* SECTION 3 */}
                        <div
                            className="mt-3"
                            id="what-the-google-algorithm-actually-changed-inside-discover"
                        >
                            <h4>What the Google Algorithm Actually Changed Inside Discover</h4>

                            <p>
                                Google focused on three main factors: local relevance,
                                reduction of clickbait, and stronger topic expertise.
                            </p>
                        </div>


                        {/* SECTION 4 */}
                        <div
                            className="mt-3"
                            id="the-local-content-advantage-that-us-businesses-should-be-capitalizing-on-right-now"
                        >
                            <h4>
                                The Local Content Advantage That U.S. Businesses Should Be
                                Capitalizing on Right Now
                            </h4>

                            <p>
                                Google Discover now favors local publishers and regionally
                                relevant content.
                            </p>
                        </div>


                        {/* FAQ */}
                        {/* FAQ */}
                        {<BlogFAQ />}

                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default InternalBlog;